export default __webpack_public_path__ + "static/media/service-thumb-masonry-curb.0c4477e2.jpg";